import { config } from '_config';

export const getApiProxyUrl = (fallback = null) => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${config.basePath || ''}/crm`;
  }

  return fallback;
};
